import React, { Component } from "react";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div className="app">
        <nav>
          <ul>
            <li>
              <a href="#schwoertemeu">Schwoertemeu</a>
            </li>
            <li>
              <a href="#hurzelsknepfle">Hurzelsknepfle</a>
            </li>
            <li>
              <a href="#beignets-accacia">Beignets de fleurs d'accacia</a>
            </li>
          </ul>
        </nav>
        <div className="recipes">
          <div className="recipe">
            <h1 id="schwoertemeu">Schwoertemeu</h1>
            <p>
              Le <i>Schwoertemeu</i>
              <a href="#schwoertemeu-note-1">
                <sup>1</sup>
              </a>{" "}
              est une sorte de fromage de tête alsacien. On fait cuire les abats
              du cochon (tête, pieds, cœur, langue), dont on farcit l'estomac.
              On refait cuire le tout, puis on le passe au fumoir.
            </p>
            <p>
              Mon arrière grand-mère Ginette, une alsacienne exilée en Lorraine,
              préparait ce plat à chaque fois qu'à la ferme on tuait le cochon.
              Une fois qu'on avait préparé les saucisses fumées, jambons et
              autres préparations permettant de conserver tous les morceaux du
              cochon, le Schwoertemeu arrivait comme la récompense, selon ma
              mère, d'avoir supporté pendant des jours l'odeur écoeurante du
              saindoux dans la cuisine.
            </p>
            <p>
              D'après ma grand-mère, Anne-Marie, qui m'a raconté cette recette
              sur un coin de table un soir d'été, le Schwoertemeu était attendu
              avec impatience à peine le cochon égorgé. Il ne faisait pas long
              feu devant la tablée qui réunissait trois générations, dont les
              fameux tontons Victor et Jean, connus dans la famille pour deux
              choses : être rentrés du front Russe à pied en 1919, et leur
              appétit gargantuesque.
            </p>
            <h2>Ingrédients</h2>
            <ul>
              <li>
                Un cochon (d'un an minimum) dont on prélèvera :
                <ul>
                  <li>Tête</li>
                  <li>Coeur</li>
                  <li>Pieds</li>
                  <li>Estomac</li>
                </ul>
              </li>
              <li>
                Épices
                <ul>
                  <li>Gingembre</li>
                  <li>Poivre</li>
                  <li>Muscade</li>
                  <li>Clou de girofle</li>
                </ul>
              </li>
              <li>
                Aromates
                <ul>
                  <li>Bouquet garni (thym, laurier...)</li>
                  <li>Échalotte / Oignon</li>
                </ul>
              </li>
            </ul>
            <h2>Recette</h2>
            <h3>D'abord la tête... et les pieds</h3>
            <ol>
              <li>
                Nettoyer et raser les pattes, préalablement débarrassées des
                onglons.
              </li>
              <li>
                <p>
                  Rincer la tête dans plusieurs eaux, puis la laisser tremper
                  une heure dans de l'eau claire, et enfin rincer de nouveau. On
                  peut ajouter du vinaigre dans l'eau.
                </p>
                <p>
                  Retirer la cervelle pour la manger fraiche ; on peut garder
                  les bas-joues pour faire du petit salé.
                </p>
                <p>
                  Pour nettoyer les oreilles, on incise à la base du lobe pour
                  pouvoir faire ressortir l'intérieur de l'oreille pour la
                  nettoyer.
                </p>
                <p>
                  Trancher le groin pour pouvoir bien nettoyer l'intérieur de la
                  gueule.
                </p>
                <p>Couper le coeur en deux et bien le nettoyer.</p>
              </li>
              <li>
                Mettre la tête dans une grande casserole d'eau froide avec un
                bouquet garni (oignon, clou de girofle, laurier) avec les
                pattes, bien lavées et rasées.
              </li>
              <li>
                Porter à ébullition, puis laisser cuire à petit bouillon en
                écumant régulièrement.
              </li>
              <li>
                Ajouter le coeur et la langue une heure avant la fin
                <a href="#schwoertemeu-note-2">
                  <sup>2</sup>
                </a>{" "}
                (ils doivent cuire moins longtemps que le reste).
              </li>
              <li>
                Quand tout est bien cuit, séparer les os du reste. Garder le jus
                de cuisson.
              </li>
              <li>Mettre la viande dans un grand plat, laisser refroidir.</li>
            </ol>
            <h3>Découper et assaisonner</h3>
            <ol>
              <li>
                Quand c'est bien froid, tailler des morceaux, et couper les en
                lamelles fines.
              </li>
              <li>Peler la langue, et la couper en morceaux.</li>
              <li>Ajouter un bol d'échalottes grises hachées.</li>
              <li>
                Ajouter du jus du cuisson, jusqu'à ce que la consistance soit
                bonne (le jus va devenir de la gélatine).
              </li>
              <li>
                Saler, poivrer, ajouter un peu de gingembre, et un peu de
                vinaigre (pas trop, car le vinaigre empêche de prendre)
                <a href="#schwoertemeu-note-3">
                  <sup>3</sup>
                </a>{" "}
              </li>
              <li>
                Refaire cuire la préparation pour deux bouillons
                <a href="#schwoertemeu-note-4">
                  <sup>4</sup>
                </a>{" "}
                la viande afin de mélanger les épices. Puis laisser refroidir.
              </li>
            </ol>
            <h3>L'estomac</h3>
            <p>
              <i>Note : une tête fait trop de viande pour un estomac.</i>
            </p>
            <ol>
              <li>
                <p>
                  Retirer la première peau de l'estomac à cru (on garde la plus
                  belle, la plus blanche).
                </p>
                <p>
                  Attention, si on le fait mal, l'estomac risque de se percer à
                  la cuisson.
                </p>
              </li>
              <li>
                Placer un entonnoir à l'entrée de l'estomac, et le remplir avec
                la viande cuite.
              </li>
              <li>Ficeler les extrémités de l'estomac une fois rempli.</li>
              <li>
                Mettre l'estomac dans une cocotte. Mettre à niveau avec de l'eau
                froide.
              </li>
              <li>
                Poser une planche à découper sur l'estomac avec un poids dessus
                (environ 600g en tout, répartis sur tout la surface de la
                planche)
                <a href="#schwoertemeu-note-5">
                  <sup>5</sup>
                </a>
                .
              </li>
              <li>
                Faire chauffer jusqu'à frémissement, environ une heure (pas
                sûr).
              </li>
              <li>
                Si l'eau est claire, c'est que c'est réussi, sinon il ne reste
                plus qu'à pleurer. Une eau trouble signifie en effet que
                l'estomac s'est percé et que l'eau de cuisson s'y est
                engouffrée.
              </li>
              <li>
                Retirer doucement l'eau avec une louche, sans bouger l'estomac.
                Attendre le lendemain que ça soit froid.
              </li>
            </ol>
            <h3>Fumer</h3>
            <ol>
              <li>
                Pour le fumer, prendre une ficelle, et faire une résille tout
                autour de l'estomac (attention il reste fragile), pour pouvoir
                le pendre sans qu'il ne s'abîme.
              </li>
              <li>Fumer le Schwoertemeu</li>
            </ol>
            <h2>Notes</h2>
            <ol>
              <li id="schwoertemeu-note-1">
                orthographe incertaine, ça s'écrit "comme ça se prononce"
                d'après ma grand-mère
              </li>
              <li id="schwoertemeu-note-2">
                Durée indéterminée, on imagine que ça cuit quelques heures
                jusqu'à ce que les morceaux soient tendres et se détachent
                facilement.
              </li>
              <li id="schwoertemeu-note-3">
                Un bouchon, deux verres ? On ne sait pas.
              </li>
              <li id="schwoertemeu-note-4">?</li>
              <li id="schwoertemeu-note-5">
                Une telle précision peut surprendre dans cette recette, elle
                n'est dûe qu'à l'utilisation de vieilles balances à poids en
                fonte.
              </li>
            </ol>
          </div>
          <div className="recipe">
            <h1 id="hurzelsknepfle">Hurzelsknepfle</h1>
            <p>
              Les Hurzelsknepfle sont un dessert Alsacien. Ce sont de petits
              pains briochés cuits à la vapeur dans un fond de caramel.
            </p>
            <h2>Ingrédients</h2>
            <ul>
              <li>
                Pains (pâte à brioche)
                <ul>
                  <li>Farine</li>
                  <li>Oeufs</li>
                  <li>Crème (optionnel)</li>
                  <li>Levure de boulanger</li>
                  <li>Lait</li>
                  <li>Sucre</li>
                </ul>
              </li>
              <li>
                Caramel
                <ul>
                  <li>
                    Sucre (15 morceaux pour une dizaine de hurzelsknepfle)
                  </li>
                  <li>Eau</li>
                  <li>Saindou (ou de l'huile d'olive)</li>
                </ul>
              </li>
            </ul>
            <h2>Recette</h2>
            <ol>
              <li>
                Faire une pâte à brioche, puis en faire des boules de la taille
                d'un gros oeuf.
              </li>
              <li>
                Mettre le sucre dans d'huile chaude, faire carmaméliser, et
                ajouter un bol d'eau.
              </li>
              <li>
                Prendre les boules de pâte levée, et les déposer dans le
                caramel, et couvrir.
              </li>
              <li>Surtout, ne plus soulever le couvercle.</li>
              <li>
                Lorsqu'on entend crépiter, c'est que c'est cuit. Alors on
                retirer le couvercle d'un coup sec, pour éviter de faire tomber
                de l'eau dans la casserole.
              </li>
            </ol>
          </div>
          <div className="recipe">
            <h1 id="beignets-accacia">Beignets de fleurs d'accacia</h1>
            <h2>Ingrédients</h2>
            <ul>
              <li>des fleurs d'accacia sur leur tige</li>
              <li>de l'huile</li>
              <li>
                Pâte à beignets
                <ul>
                  <li>2 cuillères à soupe de farine</li>
                  <li>1 cuillère à soupe de Maïzena</li>
                  <li>1 oeuf dont le blanc battu en neige</li>
                  <li>un peu de sucre vanillé</li>
                </ul>
              </li>
            </ul>
            <h2>Recette</h2>
            <ol>
              <li>Citronner les fleurs.</li>
              <li>Faire une pâte à beignet.</li>
              <li>
                Tremper les tiges dans la pâte à beignet, puis les faire frire.
              </li>
              <li>Servir tout de suite.</li>
            </ol>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js